import { useEffect } from "react"

export default function IINJotform() {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://form.jotform.com/jsform/243266205590152";
    script.type = "text/javascript";
    script.async = true;

    const container = document.getElementById("jotform-content");
    if (container) {
      container.appendChild(script);
    }
    const handleIframeLoad = () => {
      const frame = document.getElementById("243266205590152");
      if (frame) {
        frame.style.height = "710px";
      }
    };
    window.addEventListener("load", handleIframeLoad);

    return () => {
      window.removeEventListener("load", handleIframeLoad);
    };
  }, []);

  return (
    <div
      className="flex flex-col items-center justify-center w-full py-[56px] md:py-[96px] gap-10 mx-auto md:px-[144px] px-4 sm:px-8"
    >
      {/* Title and Subtitle */}
      <div className="flex flex-col gap-4 text-center">
        <h1
          className="text-[#0D0D0D] font-bold text-4xl md:text-5xl leading-tight tracking-[-0.06em]"
          style={{
            marginBottom: "4px",
          }}
        >
          Can’t make it to the January
          <br />
          Business Blueprint <span className="italic font-thin">for </span>
          <span>Health Coaches</span>?
        </h1>
        <p className="text-black text-[22px] font-normal mt-[-6px]">
          Join the waitlist to get notified about future program dates!
        </p>
      </div>

      {/* Jotform Embed Placeholder */}
      <div className="w-full max-w-md h-auto flex flex-col justify-center items-center  rounded-lg">
        <div
          id="jotform-container"
          className="w-full max-w-lg flex flex-col justify-center items-center rounded-lg p-4 bg-[#5865F2] shadow-md"
        >
          <div
            id="jotform-content"
            className="w-full h-fit p-6 bg-white rounded-md"
          ></div>
        </div>
      </div>
    </div>
  )
}